import CustomTooltip from '../feature/shared/CustomTooltip';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MinimizeIcon from '@mui/icons-material/Minimize';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import {
    Box,
    Fade,
    Grid,
    IconButton,
    Paper,
    Typography,
    useTheme,
} from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { selectShowAiChat, setAiChat } from '../app/Slices/AiAssistantSlice';
import AIGuestReservationsAssistant from '../feature/components/Reservations/AIReservations/AIGuestReservationAssistant';
import { CustomButton } from './styledcomponents/CustomButton';

const AIAssistant = () => {
    const location = useLocation();
    const showChat = useSelector(selectShowAiChat);

    const theme = useTheme();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleMaximize = () => {
        navigate(`/reservations/ai-assistant`);
    };

    const handleToggle = () => {
        dispatch(setAiChat(!showChat));
    };

    if (location?.pathname?.includes('messages')) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 20,
                right: 24,
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                gap: 2,
                height: !showChat ? '30px' : '610px',
            }}
        >
            {!showChat && (
                <Fade in={!showChat} timeout={300}>
                    <Box>
                        <CustomTooltip
                            title='AI Reservation Assistant'
                            placement='left'
                        >
                            <CustomButton
                                variant='contained'
                                color='green'
                                aria-label='Open AI Reservation Assistant'
                                sx={{
                                    minWidth: 48,
                                    width: 48,
                                    minHeight: 48,
                                    height: 48,
                                    p: 0,
                                    borderRadius: '50%',
                                    color: theme.palette.common.white,
                                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                                    border: `1px solid ${theme.palette.primary.dark}`,
                                    boxShadow: `0 10px 24px rgba(0, 0, 0, 0.2)`,
                                    '&:hover': {
                                        transform: 'translateY(-1px)',
                                        boxShadow: `0 14px 28px rgba(0, 0, 0, 0.26)`,
                                        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                                    },
                                    '&:active': {
                                        transform: 'translateY(0)',
                                    },
                                }}
                                onClick={handleToggle}
                            >
                                <Box
                                    sx={{
                                        position: 'relative',
                                        width: 24,
                                        height: 24,
                                        display: 'grid',
                                        placeItems: 'center',
                                    }}
                                >
                                    <CalendarMonthIcon sx={{ fontSize: 20 }} />
                                    <AutoAwesomeIcon
                                        sx={{
                                            fontSize: 12,
                                            position: 'absolute',
                                            right: -6,
                                            top: -4,
                                            opacity: 0.95,
                                        }}
                                    />
                                </Box>
                            </CustomButton>
                        </CustomTooltip>
                    </Box>
                </Fade>
            )}

            {showChat && (
                <Fade in={showChat} timeout={300}>
                    <Paper
                        elevation={4}
                        sx={{
                            width: 400,
                            // overflow: 'auto',
                            position: 'relative',
                            p: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            minHeight: '610px',
                        }}
                    >
                        <Box
                            sx={{
                                position: 'sticky',
                                top: 0,
                                zIndex: 1,
                                backgroundColor: 'background.paper',
                                borderBottom: `1px solid ${theme.palette.midGrey.main}`,
                                px: 2,
                                py: 1.5,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <Typography variant='subtitle1' fontWeight={600}>
                                <AutoAwesomeIcon /> Reservation Assistant
                            </Typography>

                            <Grid
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                {' '}
                                <IconButton size='small' onClick={handleToggle}>
                                    <MinimizeIcon
                                        sx={{
                                            fontSize: '25px',
                                            paddingBottom: '5px',
                                        }}
                                    />
                                </IconButton>{' '}
                                <IconButton
                                    size='small'
                                    onClick={handleMaximize}
                                >
                                    <OpenInFullIcon sx={{ fontSize: '20px' }} />
                                </IconButton>
                            </Grid>
                        </Box>

                        <Box
                            sx={{
                                pl: 1,
                            }}
                        >
                            <AIGuestReservationsAssistant isSmallChat={true} />
                        </Box>
                    </Paper>
                </Fade>
            )}
        </Box>
    );
};

export default AIAssistant;
